export const trainingCatalogTr = {
  title: '200\'den Fazla Eğitim Programı Mevcut',
  subtitle: 'Tanıtmak için bir eğitim seçin ve komisyon kazanmaya başlayın',
  searchPlaceholder: 'Eğitim ara...',
  noTrainingsFound: 'Eğitim bulunamadı',
  noTrainingsDesc: 'Arama veya filtre kriterlerinizi ayarlamayı deneyin',
  categories: {
    all: 'Tümü',
    personalDevelopment: 'Kişisel Gelişim',
    coachingLeadership: 'Koçluk & Liderlik',
    childDevelopment: 'Çocuk Gelişimi',
    healthSector: 'Sağlık Sektörü',
    digitalMarketing: 'Dijital Pazarlama',
    artificialIntelligence: 'Yapay Zeka',
    cyberSecurity: 'Siber Güvenlik',
    businessManagement: 'İş & Yönetim',
    sportsFitness: 'Spor & Fitness'
  }
};